import { TRPCClientError } from "@trpc/client";
import { TRPCAuthError } from "./TRPCAuthError";

/**
 * Checks if an error is an authentication error (401/403) that should not be
 * thrown to error boundaries. Auth errors are handled by redirecting to login.
 * This includes:
 * - TRPCClientError caused by a TRPCAuthError
 */
export function isAuthError(error: unknown): boolean {
  return (
    error instanceof TRPCClientError && error.cause instanceof TRPCAuthError
  );
}
